"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StylesBaseline = void 0;
var react_1 = __importStar(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var react_2 = require("@emotion/react");
var StylesBaseline_styles_1 = require("./StylesBaseline.styles");
var StylesBaseline = function (props) {
    var styles = props.styles, children = props.children;
    var theme = react_2.useTheme();
    var globalGeneralStyles = react_1.useMemo(function () {
        return StylesBaseline_styles_1.createGlobalGeneralStyles(theme);
    }, [theme]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_2.Global, { styles: globalGeneralStyles }),
        styles && react_1.default.createElement(react_2.Global, { styles: styles }),
        children));
};
exports.StylesBaseline = StylesBaseline;
StylesBaseline.propTypes = {
    // @ts-expect-error
    styles: prop_types_1.default.oneOfType([
        prop_types_1.default.object,
        prop_types_1.default.func
    ])
};
